// extracted by mini-css-extract-plugin
export default {"chip":"ProfileForm_chip__VJF8g","selected":"ProfileForm_selected__BELnT"};